export default __webpack_public_path__ + "media/color/hush-d3114456.svg";